/**
 * Layout constants for {@link SimpleSankey} when `smallData` is true (e.g. SRP activity strip).
 */

export type SankeyMargins = { top: number; right: number; bottom: number; left: number };

/** Symmetric horizontal margins so the diagram stays centred in the card; scales down on narrow widths. */
export function getSmallDataSankeyMargins(containerWidth: number): SankeyMargins {
  const side =
    containerWidth < 400
      ? 12
      : containerWidth < 480
        ? 14
        : containerWidth < 640
          ? 18
          : containerWidth < 768
            ? 26
            : 40;
  const vertical = containerWidth < 640 ? 26 : 34;
  return { top: vertical, right: side, bottom: vertical, left: side };
}

/** Fraction of `levelWidth` used as padding between columns (horizontal flow). */
export function getSankeyLevelPaddingRatio(opts: {
  smallData: boolean;
  containerWidth: number;
  isSmallScreen: boolean;
}): number {
  const { smallData, containerWidth, isSmallScreen } = opts;
  if (smallData && containerWidth < 640) return 0.02;
  if (isSmallScreen) return 0.05;
  return 0.1;
}
